"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningKeyRecipe = exports.UnsealingKeyRecipe = exports.SymmetricKeyRecipe = exports.SecretRecipe = exports.PasswordRecipe = exports.Recipe = void 0;
const exceptions_1 = require("./exceptions");
const RecipeForDiceKeysApiFor = (typeRequiredByOperation) => (recipeAsObjectOrJson, optionsNotSpecifiedWithinThisStandard) => {
    const recipe = (recipeAsObjectOrJson == null || recipeAsObjectOrJson === "") ?
        {} :
        (typeof recipeAsObjectOrJson === "string") ?
            JSON.parse(recipeAsObjectOrJson) :
            recipeAsObjectOrJson;
    if (typeRequiredByOperation && recipe.type && recipe.type !== typeRequiredByOperation) {
        throw exceptions_1.InvalidRecipeTypeFieldException.create(typeRequiredByOperation, recipe.type);
    }
    return optionsNotSpecifiedWithinThisStandard ?
        Object.assign(Object.assign(Object.assign({}, optionsNotSpecifiedWithinThisStandard), { recipe })) :
        recipe;
};
exports.Recipe = RecipeForDiceKeysApiFor();
exports.PasswordRecipe = RecipeForDiceKeysApiFor("Password");
exports.SecretRecipe = RecipeForDiceKeysApiFor("Secret");
exports.SymmetricKeyRecipe = RecipeForDiceKeysApiFor("SymmetricKey");
exports.UnsealingKeyRecipe = RecipeForDiceKeysApiFor("UnsealingKey");
exports.SigningKeyRecipe = RecipeForDiceKeysApiFor("SigningKey");
//# sourceMappingURL=dicekeys-recipe.js.map